import { render, staticRenderFns } from "./ChannelMenu.vue?vue&type=template&id=120b6208&scoped=true"
import script from "./ChannelMenu.vue?vue&type=script&lang=js"
export * from "./ChannelMenu.vue?vue&type=script&lang=js"
import style0 from "./ChannelMenu.vue?vue&type=style&index=0&id=120b6208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b6208",
  null
  
)

export default component.exports